import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Rect, Pattern } from 'react-native-svg';

const MB_SVG_ImageTransparentBackgroundCheckers = React.memo((props: {
    /**
     * The style of the component's container.
     */
    containerStyle?: StyleProp<ViewStyle>
}) => {
    return (
        <View style={props.containerStyle}>
            <Svg
                width={'100%'}
                height={'100%'}
            >
                <Pattern id="star" x="0" y="0" width="16" height="16" patternUnits="userSpaceOnUse">
                    <Rect width="8" height="8" fill="#999999" />
                    <Rect x="8" y="0" width="8" height="8" fill="#666666" />
                    <Rect x="0" y="8" width="8" height="8" fill="#666666" />
                    <Rect x="8" y="8" width="8" height="8" fill="#999999" />
                </Pattern>

                <Rect width="100%" height="100%" fill="url(#star)" />
            </Svg>
        </View>
    );
});

export { MB_SVG_ImageTransparentBackgroundCheckers };
